"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var types = {
  id: "types",
  title: {
    en: "Types of Items",
    de: "Gegenstandstypen"
  },
  content: {
    en: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "Normal Items"), /*#__PURE__*/_react.default.createElement("p", null, "Items sold from NPC shops. These are normal items of average option."), /*#__PURE__*/_react.default.createElement("p", null, "Normal items exist by levels. They are of lower quality class and normal quality class."), /*#__PURE__*/_react.default.createElement("p", null, "Lower quality class items have lower options and requirements than normal class items."), /*#__PURE__*/_react.default.createElement("p", null, "Normal quality class items can be crafted with certain recipes through blacksmith NPC."), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "Fortified Items"), /*#__PURE__*/_react.default.createElement("p", null, "Fortified items can only be acquired through battles with monsters. They have better options and higher requirements than normal items. They also look different than normal items."), /*#__PURE__*/_react.default.createElement("p", null, "Fortified items can only be earned from monsters."), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "Class Items"), /*#__PURE__*/_react.default.createElement("p", null, "Class items are items with class requirements. They are speicialized to certain classes and can only be used by correct classes."), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "Monser Items"), /*#__PURE__*/_react.default.createElement("p", null, "Monster items are items used by monsters. There are certain probabilities to earn these items. These items have odd outfits and unusual options."), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "Magic Items"), /*#__PURE__*/_react.default.createElement("p", null, "Magic items are items listed above with magical options."), /*#__PURE__*/_react.default.createElement("p", null, "Magic items have options by type and level. The maximum number of options is 2."), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "Rare Items"), /*#__PURE__*/_react.default.createElement("p", null, "Rare items have more magical options than magic items. These are rare."), /*#__PURE__*/_react.default.createElement("p", null, "Rare items have a minimum of 3 and maximum of 6 options."), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "Craft Recipes"), /*#__PURE__*/_react.default.createElement("p", null, "Craft recipes are needed to craft. The type of recipe varies by the type of monster."), /*#__PURE__*/_react.default.createElement("p", null, "Some recipes are sold from merchant NPCs in towns and cities, but most come from monsters."))
  }
};
var _default = types;
exports.default = _default;